import React from 'react';
import Label from 'shared/components/label';
import {startCase} from 'lodash';
import FormikTextField from 'src/components/FormikTextField';
import FormikCheckbox from 'src/components/formik-checkbox';
import Index, {FormikMultiselectProps} from '../FormikMultiselect/FormikMultiselect';

interface CommonFieldComponentProps {
  name: string | number;
  required?: boolean;
  label?: string;
}

type MultiselectFieldComponentProps = CommonFieldComponentProps &
  Pick<FormikMultiselectProps, 'options'> & {
    type: 'multi-select';
  };

type FieldComponentProps = CommonFieldComponentProps & {
  type: string;
  withLabel?: boolean;
};

const FieldComponent = ({
  type,
  name,
  required,
  label,
  ...remainingProps
}: FieldComponentProps | MultiselectFieldComponentProps): React.ReactElement => {
  const stringifiedName = String(name);
  let input;

  if (type === 'multi-select' && 'options' in remainingProps) {
    input = <Index name={stringifiedName} options={remainingProps.options} />;
  } else {
    const InputComponent = type === 'checkbox' ? FormikCheckbox : FormikTextField;
    const componentProps = type === 'checkbox' ? {} : {required: required, type: type};
    input = <InputComponent name={stringifiedName} {...componentProps} {...remainingProps} />;
  }

  if (!remainingProps['withLabel']) {
    return input;
  }

  return (
    <Label>
      {label || startCase(stringifiedName.split('.').pop())}
      {input}
    </Label>
  );
};

FieldComponent.defaultProps = {
  withLabel: true,
};

/**
 * @deprecated Use Checkbox, TextInput, or TextArea directly instead.
 */
export default FieldComponent;
